module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/skeleton-star.418ccf71.svg";